import { PropsWithChildren, ReactNode } from 'react';

export interface Props {
    children?: ReactNode;
    bannerComponent?: ReactNode;
}

interface LayoutWithBannerProps {
    children?: ReactNode;
}

export const createLayoutWithBanner = (Layout: React.ComponentType<Props>, bannerComponent: ReactNode) => {
    return function LayoutWithBanner({ children }: PropsWithChildren<LayoutWithBannerProps>) {
        return <Layout bannerComponent={bannerComponent}>{children}</Layout>;
    };
};
